module.exports = __webpack_public_path__ + "static/media/OW.510a0144.png";